export default "__VITE_PUBLIC_ASSET__85d6c76f__"